// The one colour scale the Welcome Survey reports read on. Kept here rather
// than beside any one of them because all three — the Report tab's rep panel,
// the Rep Quality board and the Account Quality table — have to agree: a figure
// that is green on one of them cannot be amber on another.
//
// Only the figures that measure how well something is going are banded at all.
// Volumes and money are left black on every report: a large number there is
// neither good nor bad on its own, and colouring it would claim otherwise.
const GOOD = 90;
const FAIR = 75;

/// Where a 0-100 figure sits on the scale: better than 90 is green, 75 through
/// 90 is amber, under 75 is red.
///
/// 90 itself lands in green rather than amber — a round target is normally met
/// by reaching it, not by passing it. Move the comparison to `>` here if the
/// intent is the stricter reading.
export function valueBand(percentage) {
  const number = Number(percentage);
  if (!Number.isFinite(number)) return "neutral";
  if (number >= GOOD) return "good";
  if (number >= FAIR) return "fair";
  return "poor";
}

/// The same scale for a figure whose good end is the low one — rescissions and
/// cancellations, where 4% is a good week and 40% is a bad one. The scale measures how well
/// something is going, so what it bands is the share that did NOT go wrong:
/// 4% rescinded is 96% not rescinded, and green.
export function invertedBand(percentage) {
  const number = Number(percentage);
  if (!Number.isFinite(number)) return "neutral";
  return valueBand(100 - number);
}
